import {AllInBox} from "./AllInBox";

import {LivewireListeners} from "./livewire/LivewireListeners";
import {WebsocketsInitializer} from "./websockets/WebsocketsInitializer";
import ClipboardJS from "clipboard";
import toastr from 'toastr';
import {Wizard} from "./wizard/Wizard";

window.toastr = toastr;

LivewireListeners.init();
WebsocketsInitializer.websockets();

addEventListener('DOMContentLoaded', (event) => {
    AllInBox.init();
    let wizard = new Wizard();

    wizard.init();

    toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": true,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "10000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "slideDown",
        "hideMethod": "fadeOut"
    };

    let aibFlashMessages = window.aibFlashMessages ?? [];

    aibFlashMessages.forEach((flash) => {
        switch (flash.level) {
            case 'success':
                toastr.success(flash.message, flash.title);
                break;
            case 'danger':
                toastr.error(flash.message, flash.title);
                break;
            case 'info':
                toastr.info(flash.message, flash.title);
                break;
            case 'warning':
                toastr.warning(flash.message, flash.title);
                break;
        }
    });

    new ClipboardJS('.copy-to-clipboard');
});